import $ from 'jquery'
import { Fancybox } from '@fancyapps/ui'

const initializeBlock = function ($block) {
  const id = $block.attr('data-id')

  Fancybox.bind(`[data-gallery="gallery-block-${id}"]`, {
    groupAll: true,
    Toolbar: {
      display: {
        left: [],
        middle: [],
        right: ['close'],
      },
    },
    Thumbs: {
      type: 'classic',
    },
  })
}

$('.gallery-block').each(function () {
  initializeBlock($(this))
})

if (window.acf) {
  window.acf.addAction('render_block_preview/type=cc-gallery', initializeBlock)
}
